import { j as r } from "../../../jsx-runtime-B6kdoens.js";
import { c as j } from "../../../index-CROKJrb5.js";
import { c as C, f as z } from "../../../create-component-CBAeEoQ6.js";
import { useAccordionStateAtoms as I } from "../AccordionState/index.js";
import { u as S } from "../../../use-breakpoints-Kqi6S3m8.js";
import { MinusIcon as N } from "../../Icon/icons/MinusIcon/index.js";
import { PlusIcon as h } from "../../Icon/icons/PlusIcon/index.js";
import { AccordionCaretUpIcon as w } from "../../Icon/icons/AccordionCaretUpIcon/index.js";
import { AccordionCaretDownIcon as v } from "../../Icon/icons/AccordionCaretDownIcon/index.js";
import { u as e, a as L } from "../../../react-B_GApDuV.js";
const X = j({
  base: "cur-font-bold cur-flex",
  variants: {
    size: {
      md: "cur-leading-[1.5rem]",
      lg: "lg:cur-text-body-lg lg:cur-leading-body-lg"
    },
    type: {
      default: "cur-border-t",
      nested: "cur-text-brand"
    }
  },
  compoundVariants: [
    {
      size: "md",
      type: "default",
      className: "cur-py-2"
    },
    {
      size: "lg",
      type: "default",
      className: "cur-py-3"
    }
  ]
}), k = (t, o) => {
  const { isLarge: s, isXLarge: c, isXXLarge: n } = S();
  return o === "nested" ? t === "md" ? "sm" : "md" : t === "md" || s || c || n ? "md" : "lg";
}, R = (t, o) => o === "nested" ? t ? N : h : t ? w : v, q = C(
  "AccordionSummary",
  z(
    ({ as: t, children: o, className: s, ...c }, n) => {
      const d = t || "div", { openAtom: l, idAtom: p, toggleAtom: f, sizeAtom: g, typeAtom: x } = I(), i = e(p), y = L(f), a = e(l), u = e(g), m = e(x), A = k(u, m), b = R(a, m);
      return /* @__PURE__ */ r.jsx(
        d,
        {
          ref: n,
          className: X({
            className: s,
            size: u,
            type: m
          }),
          ...c,
          children: /* @__PURE__ */ r.jsxs(
            "button",
            {
              id: `button-${i}`,
              type: "button",
              onClick: y,
              className: "cur-flex cur-grow cur-cursor-pointer cur-items-center cur-justify-start",
              "aria-expanded": a,
              "aria-controls": i,
              children: [
                /* @__PURE__ */ r.jsx("span", { className: "cur-grow cur-pr-4 cur-text-left", children: o }),
                /* @__PURE__ */ r.jsx("span", { className: "cur-text-primary", title: a ? "Close" : "Open", children: /* @__PURE__ */ r.jsx(b, { size: A }) })
              ]
            }
          )
        }
      );
    }
  )
);
export {
  q as AccordionSummary
};
//# sourceMappingURL=index.js.map
